import { CartRewardsType } from "@redotech/redo-model/cart/cart-rewards";
import { createEnum } from "@redotech/zod/zod-enum";
import * as z from "zod/v4";

export const CartRewardsSettingsSchema = z.object({
  threshold: z.number().min(0),
  type: createEnum(CartRewardsType),
  approachingThresholdMessage: z.string().optional(),
  pastThresholdMessage: z.string().optional(),
  placementSelector: z.string().optional(),
  enabled: z.boolean().optional(),
});
export type CartRewardsSettings = z.infer<typeof CartRewardsSettingsSchema>;

export const CartTotalsSettingsSchema = z.object({
  placementSelector: z.string().optional(),
  enabled: z.boolean().optional(),
  customCss: z.string().optional(),
});
export type CartTotalsSettings = z.infer<typeof CartTotalsSettingsSchema>;

export const editCartOptimizationSettings = {
  name: "editCartOptimizationSettings" as const,
  input: z.object({
    cartRewards: CartRewardsSettingsSchema.optional(),
    cartTotals: CartTotalsSettingsSchema.optional(),
  }),

  output: z.object({ success: z.boolean() }),
};
